import { topicTags } from '@/mocks/home';

export default function Topics() {
  return (
    <section id="topics" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">大家都在关注的热门漫画话题标签</p>
        <div className="flex flex-wrap gap-2 md:gap-3">
          {topicTags.map((tag, idx) => {
            const colors = ['primary', 'accent', 'secondary'];
            const color = colors[idx % 3];
            return (
              <a
                key={tag.id}
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`inline-flex items-center gap-2 px-3 md:px-4 py-2 rounded-full cursor-pointer transition-colors whitespace-nowrap ${
                  color === 'primary'
                    ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                    : color === 'accent'
                    ? 'bg-accent-100 text-accent-700 hover:bg-accent-200'
                    : 'bg-secondary-100 text-secondary-800 hover:bg-secondary-200'
                }`}
              >
                <span className="text-sm font-medium">{tag.name}</span>
                <span className="text-xs opacity-70">{tag.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}